<template>
	<VInput
		ref="company-mwstTvaIva"
		v-model="company.additionalAttributes.uscc.value"
		:label="company.additionalAttributes.uscc.name"
		layout="vertical"
		:validate-method="ChUtils.validateMWST"
		:disabled="readOnly"
	/>
</template>

<script>

import ChUtils from '@/core/utils/regional/ChUtils'
import Company from "@/domains/Companies/Company.js";

export default {
	name:   'CNAdditionalAttributes',

	props: {
    company: {
      type:     Company,
      required: true
    },
		readOnly: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			ChUtils,
		}
	},
};
</script>
